// Engine.io is _close_ to the WebSocket API, but not quite
// exact. ShareDB depends on its socket implementing the WebSocket API
// correctly. This class wraps an Engine.io socket with a
// WebSocket-compatible wrapper.
export default class WebSocketWrapper {
  static readyStateMap = {
    opening: 0,
    open: 1,
    closing: 2,
    closed: 3,
  };

  onopen = null;
  onmessage = null;
  onerror = null;
  onclose = null;

  wrapSocket(socket) {
    if (this.socket) {
      this._removeListeners();
    }

    this.socket = socket;

    this.socket.on('open', this._onOpen);
    this.socket.on('error', this._onError);
    this.socket.on('close', this._onClose);
  }

  // We don't listen to the 'message' event from the Engine.io socket
  // directly, to give our owner the chance to filter out
  // messages. This is because we have to send errors as normal
  // messages, but don't want those to get into sharedb.
  triggerMessage(data) {
    const event = {
      target: this,
      data,
    };
    this.onmessage && this.onmessage(event);
  }

  send(data) {
    this.socket.send(data);
  }

  close() {
    this._removeListeners();
    this.socket.close();
  }

  get readyState() {
    return WebSocketWrapper.readyStateMap[this.socket.readyState];
  }

  _onOpen = () => {
    const event = {
      target: this,
    };
    this.onopen && this.onopen(event);
  };

  _onError = () => {
    const event = {
      target: this,
    };

    this.onerror && this.onerror(event);
  };

  _onClose = () => {
    const event = {
      target: this,
    };

    this.onclose && this.onclose(event);
  };

  _removeListeners() {
    this.socket.removeListener('open', this._onOpen);
    this.socket.removeListener('error', this._onError);
    this.socket.removeListener('close', this._onClose);
  }
}
